export default class {
    constructor(dto) {
    
        this.Value = dto.Value;
        this.Selected = dto.Selected;
        this.Weight = dto.Weight;
        this.Id = dto.Id;
        this.UpdatedAt = dto.UpdatedAt;
    }
}